function getBlock(blockId, blocks) {
	let block = null;
	for (let i = 0; i < blocks.length; i++) {
		if (blocks[i]._id === blockId) {
			block = blocks[i];
			break;
		}
	}
	return block;
}

function populateBlocks(blocksArray, blocks) {
	let populatedBlocks = [];
	for (let i = 0; i < blocks.length; i++) {
		if (blocksArray.includes(blocks[i]._id)) {
			populatedBlocks.push(blocks[i]);
		}
	}
	return populatedBlocks;
}

function traverseBlocks(blockId, blocks) {
	let currentBlock = getBlock(blockId, blocks);
	let blocksArray = populateBlocks(currentBlock.blocks, blocks);
	let newBlocks = [];
	findErrors(currentBlock, blocks);
	for (let i = 0; i < blocksArray.length; i++) {
		newBlocks.push(blocksArray[i]);
		if (blocksArray[i].blocks.length > 0) {
			newBlocks = newBlocks.concat(traverseBlocks(blocksArray[i]._id, blocks));
		}
	}
	return newBlocks;
}

function findErrors(block, blocks) {
	let errors = [];
	let blocksArray = block.blocks;
	let populatedBlocks = [];
	for (let i = 0; i < blocksArray.length; i++) {
		let block = null;
		for (let j = 0; j < blocks.length; j++) {
			if (blocks[j]._id === blocksArray[i]) {
				block = blocks[j];
				break;
			}
		}
		if (!block) {
			errors.push({
				blockId: blocksArray[i]
			});
			continue;
		}
		populatedBlocks.push(block);
	}
	console.log('ERRORS', errors);
	// return {
	// 	errors: errors,
	// 	blocks: populatedBlocks
	// };
}

function findDangles(blockId, blocks) {
	console.time('FIND-DANGLES');
	let block = getBlock(blockId, blocks);

	let newBlocks = traverseBlocks(blockId, blocks);

	console.timeEnd('FIND-DANGLES');
	return newBlocks;
}

export default findDangles;
